import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';

export const gqlUri = process.env.REACT_APP_GQL_SERVER_URL;
export const clientNoAuth = new ApolloClient({
    link: ApolloLink.from([
        new HttpLink({
            uri: gqlUri,
        }),
    ]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
});
